import { Component, Input, ContentChild } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CardDirective } from './card.directive';

/**
 * A reusable carousel component wrapping around the popular and feature-rich
 * Swiper open-source slider component: https://idangero.us/swiper/
 * This specific component is akin to an abstract type, it allows supplying custom
 * templates to Swiper by child components, which is demonstrated by
 * SocialMediaComponent and SupplierSpecialsComponent. The styling of the Swiper
 * is controlled from within this component. When child components need to manage
 * a portion of the styles, this component needs to expose them as input
 * parameters, and child components provide style overrides as inputs to this component.
 * Exactly this is done with previous and next button styles.
 */
@Component({
  selector: 'app-swiper-slider',
  templateUrl: './swiper-slider.component.html',
  styleUrls: ['./swiper-slider.component.scss']
})
export class SwiperSliderComponent {
  @Input() public config: SwiperConfigInterface;
  @Input() public items: Array<any>;
  @Input() public prevButtonStyle: { [klass: string]: any; };
  @Input() public nextButtonStyle: { [klass: string]: any; };
  @ContentChild(CardDirective) public sliderCard: CardDirective;
}
